import React from 'react';
import './MobileAppTeaser.css';

export default function MobileAppTeaser() {
  return (
    <div className="mat-wrap">
      <div className="mat-card">
        <div className="mat-logo">
          <img src="/apple-touch-icon.png" alt="CVFlow" />
        </div>
        <h1 className="mat-title">CVFlow App<br /><em>jetzt im App Store</em></h1>
        <p className="mat-text">
          Lade die CVFlow App für dein iPhone herunter und starte deine Bewerbung direkt mobil.
        </p>
        <a
          href="https://apps.apple.com/de/app/cvflow/id6778375720"
          className="mat-btn mat-btn--primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Im App Store laden
        </a>
        <p className="mat-note">Die Android-App ist noch nicht veröffentlicht.</p>
        <div className="mat-divider">oder</div>
        <p className="mat-hint">
          Für den vollen Funktionsumfang die Website auf dem <strong>PC oder Mac</strong> öffnen.
        </p>
        <a href="https://cvflow.de" className="mat-btn mat-btn--ghost">
          cvflow.de am Desktop öffnen
        </a>
      </div>
    </div>
  );
}
